import { render, staticRenderFns } from "./ZTag.vue?vue&type=template&id=9f5db22c&"
import script from "./ZTag.vue?vue&type=script&lang=ts&"
export * from "./ZTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports